import React from "react";
import "../new_login_page/scrollableCardCmp.css";

function ScrollableCardCmp({ title, children }) {
  console.log(window.screen.width);
  return (
    <div className="scrollable-card-section">
      <div className="section-title">{title}</div>
      <div
        className="info-section-scrollable"
        style={
          children.length > 3
            ? {}
            : window.screen.width > 600
            ? { justifyContent: "center" }
            : {}
        }
      >
        {children}
      </div>
    </div>
  );
}

export default ScrollableCardCmp;
